import React from "react";
import { FaFacebookF, FaLinkedinIn, FaInstagram } from "react-icons/fa";
import { BsTwitterX } from "react-icons/bs";
import { Email, LocationOn, Phone, PhoneIphone } from "@mui/icons-material";
import { useMoreApps } from "../context/MoreAppsContext";

// Define types for links and awards
interface QuickLink {
  title: string;
  url: string;
}

interface Award {
  imgSrc: string;
  link: string;
}

const Footer: React.FC = () => {
  const { openMoreApps } = useMoreApps();

  const quickLinks: QuickLink[] = [
    { title: "Home", url: "https://buoyancysoftware.com/" },
    { title: "About Us", url: "https://buoyancysoftware.com/about/" },
    { title: "Services", url: "https://buoyancysoftware.com/services/" },
    { title: "Portfolio", url: "https://buoyancysoftware.com/portfolios/" },
    { title: "Blogs", url: "https://buoyancysoftware.com/blogs/" },
    { title: "Careers", url: "https://buoyancysoftware.com/careers/" },
    { title: "Privacy Policy", url: "https://buoyancysoftware.com/privacy-policy/" },
    { title: "Sitemap", url: "https://buoyancysoftware.com/sitemap/" },
  ];

  const awards: Award[] = [
    {
      imgSrc:
        "https://shareables-prod-static.clutch.co/badges/top_clutch.co_app_development_company_dental_ahmedabad.svg",
      link: "https://clutch.co/profile/buoyancy-software-llp",
    },
    {
      imgSrc:
        "https://shareables-prod-static.clutch.co/badges/top_clutch.co_it_services_company_dental_ahmedabad.svg",
      link: "https://clutch.co/profile/buoyancy-software-llp",
    },
    {
      imgSrc:
        "https://shareables-prod-static.clutch.co/badges/top_clutch.co_software_developers_dental_india.svg",
      link: "https://clutch.co/profile/buoyancy-software-llp",
    },
    {
      imgSrc:
        "https://assets.goodfirms.co/badges/color-badge/top-website-development-companies.svg",
      link: "https://www.goodfirms.co/company/buoyancy-software",
    },
    {
      imgSrc:
        "/Buoyancy Images/DesignRush_light.png",
      link: "https://www.designrush.com/agency/profile/buoyancy-software-llp",
    },
    {
      link: "https://www.topdevelopers.co/profile/buoyancy-software-llp",
      imgSrc: "/Buoyancy Images/TopDevelopers.png",
    },
    {
      link: "https://clutch.co/profile/buoyancy-software-llp",
      imgSrc: "/Buoyancy Images/Top Clutch It Services Company Real Estate Ahmedabad 185x200.png",
    },
    {
      link: "https://buoyancysoftware.com/certificates/ISO-9001",
      imgSrc: "/Buoyancy Images/ISO-Certified-9001.png",
    },
    {
      link: "https://buoyancysoftware.com/certificates/ISO-27001",
      imgSrc: "/Buoyancy Images/ISO-Certified-27001.png",
    },
    {
      imgSrc: "/Buoyancy Images/Techbehemoths.png",
      link: "https://techbehemoths.com/company/buoyancy-software-llp",
    },
  ];

  return (
    <footer className="py-5">
      <div className="container">
        <div className="glass-panel p-4 p-md-5" style={{ borderRadius: "28px" }}>
          <div className="row g-4">
            {/* Left Section - Company Info */}
            <div className="col-12 col-lg-4">
              <a
                href="https://buoyancysoftware.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="d-inline-block mb-3"
              >
                <img
                  src="/Buoyancy Images/footer-logo.png"
                  alt="Buoyancy Software Logo"
                />
              </a>
              <p style={{ color: "#94a3b8", fontSize: "0.95rem", lineHeight: 1.6 }}>
                Buoyancy Software is a certified leader in IT Consulting, providing scalable cloud, security, and custom tools to boost business performance.
              </p>
              <div className="mt-4 d-flex gap-3">
                {/* Social Media Links */}
                <a
                  href="http://facebook.com/buoyancysoft"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    background: "rgba(255, 255, 255, 0.1)",
                    height: 38,
                    width: 38,
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textDecoration: "none",
                    border: "1px solid rgba(255, 255, 255, 0.15)",
                    transition: "all 0.3s ease",
                  }}
                >
                  <FaFacebookF color="#fff" size={16} />
                </a>
                <a
                  href="https://twitter.com/buoyancysoft"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    background: "rgba(255, 255, 255, 0.1)",
                    height: 38,
                    width: 38,
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textDecoration: "none",
                    border: "1px solid rgba(255, 255, 255, 0.15)",
                    transition: "all 0.3s ease",
                  }}
                >
                  <BsTwitterX color="#fff" size={16} />
                </a>
                <a
                  href="https://www.linkedin.com/company/buoyancysoft/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    background: "rgba(255, 255, 255, 0.1)",
                    height: 38,
                    width: 38,
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textDecoration: "none",
                    border: "1px solid rgba(255, 255, 255, 0.15)",
                    transition: "all 0.3s ease",
                  }}
                >
                  <FaLinkedinIn color="#fff" size={16} />
                </a>
                <a
                  href="https://www.instagram.com/buoyancysoft/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    background: "rgba(255, 255, 255, 0.1)",
                    height: 38,
                    width: 38,
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textDecoration: "none",
                    border: "1px solid rgba(255, 255, 255, 0.15)",
                    transition: "all 0.3s ease",
                  }}
                >
                  <FaInstagram color="#fff" size={16} />
                </a>
              </div>
            </div>

            {/* Middle Section - Quick Links */}
            <div className="col-12 col-lg-3">
              <h5 className="gradient-text mb-3" style={{ fontWeight: 700 }}>Quick Links</h5>
              <ul className="list-unstyled d-flex flex-column gap-2 mb-0">
                <li>
                  <button
                    onClick={openMoreApps}
                    id="footer-more-apps-btn"
                    className="p-0 border-0 bg-transparent text-left cursor-pointer d-flex align-items-center gap-1.5"
                    style={{ color: "#a855f7", textDecoration: "none", fontWeight: 700 }}
                  >
                    <PhoneIphone sx={{ fontSize: 16 }} /> Our Mobile Apps
                  </button>
                </li>
                {quickLinks.map((link, index) => (
                  <li key={index}>
                    <a
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#cbd5e1", textDecoration: "none", transition: "color 0.2s" }}
                    >
                      {link.title}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Right Section - Contact Info */}
            <div className="col-12 col-lg-5">
              <h5 className="gradient-text mb-3" style={{ fontWeight: 700 }}>Contact Us</h5>
              <a
                href="https://www.google.com/maps/place/Buoyancy+Software/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-none d-block mb-2"
              >
                <p style={{ color: "#cbd5e1", fontSize: "0.90rem" }}>
                  <LocationOn sx={{ color: "white" }} />
                  720, Fortune Business Hub, Science City Rd, Ahmedabad, Gujarat 380060
                </p>
              </a>
              <a
                href="mailto:info@buoyancysoftware.com"
                className="text-decoration-none d-block mb-1"
              >
                <p style={{ color: "#cbd5e1", fontSize: "0.90rem" }}><Email sx={{ color: "white" }} /> info@buoyancysoftware.com</p>
              </a>
              <p style={{ color: "#cbd5e1", fontSize: "0.90rem" }}><Phone sx={{ color: "white" }} /> +91 9265716589</p>

              {/* Awards Section */}
              <div className="mt-3 d-flex flex-wrap gap-2">
                {awards.map((award, index) => (
                  <a
                    key={index}
                    href={award.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={award.imgSrc}
                      alt={`Award ${index + 1}`}
                      style={{ width: 75, height: 75, borderRadius: "8px", objectFit: "contain" }}
                    />
                  </a>
                ))}
              </div>
            </div>
          </div>

          <hr style={{ borderColor: "rgba(255, 255, 255, 0.1)", margin: "30px 0 20px" }} />

          {/* Copyright */}
          <p className="text-center mb-0" style={{ color: "#64748b", fontSize: "0.9rem" }}>
            © 2026 Copyright Buoyancy Software LLP. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};


export default Footer;
